<template>
    <div class="tw-container">
        <div>
            <vue-good-table
                mode="remote"
                theme="rocks"

                :columns="columns"
                :rows="licences"
                :totalRows="totalRecords"

                @on-sort-change="onSortChange"
                @on-search="onSearch"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange"

                :sort-options="{
                    enabled: true,
                    multipleColumns: false,
                }"

                :search-options="{
                    enabled: true,
                    placeholder: 'Lizenzen durchsuchen...',
                }"

                :pagination-options="{
                    enabled: true,
                    perPage: serverParams.perPage,
                    perPageDropdown: [25, 50, 100],
                    dropdownAllowAll: false,
                    jumpFirstOrLast : true,

                    firstLabel : 'Erste Seite',
                    lastLabel : 'Letzte Seite',
                    nextLabel: 'nächste',
                    prevLabel: 'vorherige',
                    rowsPerPageLabel: 'Zeilen pro Seite',
                    ofLabel: 'von'
                }"

                :isLoading.sync="isLoading"
            >
                <template slot="loadingContent">
                    <div style="
                        display: inline-block;
                        color: white;
                        border: thin solid var(--color-brand-primary);
                        background-color: var(--color-brand-primary);
                        border-radius: 0.25rem;
                        padding: 0.5rem 1rem 0.5rem 1rem;
                        white-space: nowrap;
                    ">
                        Lade Daten
                    </div>
                </template>

                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'actions'">
                        <div class="tw-flex">
                            <button type="button" title="Ansehen" class="cu-btn-default-sm tw-mr-1"
                                    @click="showExpandedContent(props.row)">
                                <i class="fa fa-eye"></i>
                            </button>

                            <button v-if="canManageLicences" type="button" title="Bearbeiten" class="cu-btn-default-sm tw-mr-1"
                                    @click="editRow(props.row)">
                                <i class="fa fa-pencil"></i>
                            </button>

                            <button v-if="canManageLicences" type="button" title="Löschen" class="cu-btn-default-sm"
                                    @click="deleteRow(props.row)">
                                <i class="fa fa-trash-o"></i>
                            </button>
                        </div>
                    </span>
                </template>
            </vue-good-table>
        </div>
    </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table';
import axios from 'axios';

export default {
    components: {VueGoodTable},
    props: ['canManageLicences'],

    data() {
        return {
            isLoading: true,
            columns: [
                {label: 'Kostenträger', field: 'cost_carrier_name',},
                {label: 'Abteilung', field: 'department_name',},
                {label: 'Bezeichnung', field: 'description',},
                {label: 'Zuständigkeit', field: 'responsible_user_name',},
                {
                    label: 'Kaufdatum',
                    field: 'purchase_date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd.MM.yyyy',
                },
                {
                    label: 'Nächste Zahlung',
                    field: 'next_payment_date',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd',
                    dateOutputFormat: 'dd.MM.yyyy',
                },
                {label: 'Aktion', field: 'actions', sortable: false,},
            ],
            licences: [], // rows
            totalRecords: 0, //total rows
            serverParams: {
                sort: [],
                search: [],
                page: [],
                perPage: [],
            },
        };
    },

    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },

        onSortChange(params) {
            if (params[0].type !== 'asc' && params[0].type !== 'desc') {
                params[0].type = 'asc'; // Standardwert auf "asc" setzen
            }

            this.updateParams({sort: params});
            this.fetchData();
        },

        onSearch(params) {
            this.updateParams({search: params});
            this.fetchData();
        },

        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.fetchData();
        },

        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.fetchData();
        },

        showExpandedContent(row) {
            window.location.href = `/licences/show/${row.id}`;
        },

        editRow(row) {
            window.location.href = `/licences/${row.id}/edit`;
        },

        deleteRow(row) {
            if (confirm('Möchten Sie diese Lizenz wirklich löschen?')) {
                axios
                    .delete(`/licences/${row.id}`)
                    .then(response => {
                        if (response.data.message) {
                            alert(response.data.message);
                        }
                        this.fetchData();
                    });
            }
        },

        fetchData() {
            axios
                .get(`/licences`, {
                    params: this.serverParams,
                })
                .then(response => {
                    this.totalRecords = response.data.totalRecords;
                    this.licences = response.data.data;
                });
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>
